import {
  Component,
  ChangeDetectionStrategy,
  inject,
  signal,
} from '@angular/core';

import { IsoWeekService } from '@app/core/services/isoWeek.service';
import { NavService } from '@app/core/services/nav.service';
import { INavigationType } from '../../interfaces/navigation.interface';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { HasPermissionDirective } from '../../../../core/directives/has-permission.directive';
import { NgTemplateOutlet } from '@angular/common';
import { NavigationItemComponent } from '../navigation-item/navigation-item.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AngularSvgIconModule,
    HasPermissionDirective,
    NgTemplateOutlet,
    NavigationItemComponent,
  ],
})
export class NavigationComponent {
  // dependencies
  navService = inject(NavService);
  isoWeekService = inject(IsoWeekService);

  navigationConfig = signal<INavigationType[]>(
    this.navService.getMainNavigation(),
  );

  constructor() {}
}
